import { inject, Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

import { FORM_ERRORS } from '../messages/form-errors';

@Pipe({
  name: 'formatError',
  standalone: true,
})
export class FormatErrorPipe implements PipeTransform {
  private errors = inject<ValidationErrors>(FORM_ERRORS);

  transform(errors: ValidationErrors | null | undefined): string | null {
    if (!errors) {
      return null;
    }
    const firstKey = Object.keys(errors)[0];
    const getError = this.errors[firstKey];
    if (typeof getError !== 'function') {
      return 'Invalid value.';
    }
    return getError(errors[firstKey]);
  }
}
